export const readableDevelopmentTypes = {
  COVERED_AREA: 'aktuell bebaut',
  NOW: 'kurzfristig bebaubar',
  NEAR_FUTURE: 'zukünftig bebaubar',
  RESTRICTED: 'eingeschränkt bebaubar',
  NONE: 'nicht bebaubar',
  UNKNOWN: 'weiß nicht'
}
